import React from 'react';
import { HashRouter as Router, Route, Routes, Navigate } from 'react-router-dom';
import LoginPage from './components/LoginPage';
import MainPage from './components/MainPage';
import LandingPage from './components/LandingPage/LandingPage';
import ContentPolicyPage from './moderation/ContentPolicyPage';
import { OnboardingProvider } from './components/OnboardingContext';
import axios from 'axios';

const App = () => {

  const params = new URLSearchParams(window.location.search);
  const t = params.get('token');
  const uid = params.get('userId');
  const tutorial = params.get('tutorial');

  React.useEffect(() => {
    if (tutorial !== null) {
      if (tutorial === 'false') {
        localStorage.setItem('has_completed_tutorial', 'true');
      } else if (tutorial === 'true') {
        localStorage.setItem('has_completed_tutorial', 'false');
      }
    }
  }, [tutorial]);

  if (t && uid) {
    localStorage.setItem('token', t);
    localStorage.setItem('userId', uid);

    // Clean the URL so it doesn't keep query params
    if (window.history.replaceState) {
      window.history.replaceState({}, document.title, window.location.pathname);
    }
  }

  const [token, setToken] = React.useState(() => localStorage.getItem('token'));
  const isAuthenticated = !!token;

  React.useEffect(() => {
    // keep axios in sync so first requests on /home are authenticated
    if (token) {
      axios.defaults.headers.common['Authorization'] = `Bearer ${token}`;
    } else {
      delete axios.defaults.headers.common['Authorization'];
    }
  }, [token]);

  React.useEffect(() => {
    const sync = () => setToken(localStorage.getItem('token'));
    window.addEventListener('storage', sync);        // cross-tab
    window.addEventListener('auth:changed', sync);   // same-tab immediate
    return () => {
      window.removeEventListener('storage', sync);
      window.removeEventListener('auth:changed', sync);
    };
  }, []);

  // --- Proactive Token Expiry Check ---
  React.useEffect(() => {
    if (!token) return;

    const checkExpiry = () => {
      try {
        const payload = JSON.parse(atob(token.split('.')[1]));
        const exp = payload.exp * 1000; // convert to ms
        if (Date.now() >= exp) {
          console.warn('Token expired proactively. Logging out...');
          localStorage.removeItem('token');
          localStorage.removeItem('userId');
          localStorage.removeItem('userEmail');
          localStorage.removeItem('userStatus');
          delete axios.defaults.headers.common['Authorization'];
          window.dispatchEvent(new Event('auth:changed'));
          window.location.href = '/#/login';
        }
      } catch (e) {
        console.error('Failed to parse token expiry:', e);
      }
    };

    // Check immediately on mount/token-change
    checkExpiry();

    // Then check every 30 seconds
    const interval = setInterval(checkExpiry, 100000);
    return () => clearInterval(interval);
  }, [token]);



  return (
    <Router>
      <Routes>
        <Route path="/login" element={<LoginPage />} />
        <Route path="/reset-password" element={<LoginPage />} />

        <Route path="/content-policy" element={<ContentPolicyPage />} />

        <Route
          path="/home"
          element={
            isAuthenticated ? (
              <OnboardingProvider>
                <MainPage />
              </OnboardingProvider>
            ) : (
              <Navigate to="/login" />
            )
          }
        />
        {/* Landing Page is now the root */}
        <Route path="/" element={<LandingPage />} />
        <Route path="*" element={<Navigate to="/" />} />
      </Routes>
    </Router>
  );
};

export default App;
